module.exports = __webpack_public_path__ + "img/personas.cacc1d44.jpg";